import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
export const initialState: any = {
  Authorized: false,
  authenticated: false,
  Email: '',
  UserId: '',
  ExtranetId: '',
  Subscriber: false,
  ValidAccessToken: false,
  Benchmarks: false,
};

// Thunk API Calls
export const auth_load = createAsyncThunk('get/authTokens', async (cookiesFromReqHeader: string) => {
  // Dynamic import keeps @emarketer/auth/server out of the client bundle; only executed server-side via getServerSideProps
  const { readAccessToken } = await import('@emarketer/auth/server');
  const userAccessToken = readAccessToken(cookiesFromReqHeader);

  return {
    userAccessToken: userAccessToken,
    Benchmarks: false,
  };
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state, action: any) => {
        return {
          ...state,
          ...action.payload.auth,
        };
      })
      .addCase(auth_load.fulfilled, (state, action) => {
        if (action.payload.userAccessToken?.isAuthenticated) {
          state.Authorized = true;
          state.authenticated = true;
          state.Email = action.payload.userAccessToken.email;
          state.UserId = action.payload.userAccessToken.userId;
          state.ExtranetId = action.payload.userAccessToken.extranetId;
          state.Subscriber = action.payload.userAccessToken.loginTypeId !== '3'; // Not "Impersonation"
          state.ValidAccessToken = true;
          state.Benchmarks = action.payload.Benchmarks;
        } else {
          state.Authorized = false;
          state.authenticated = false;
          state.Email = '';
          state.UserId = '';
          state.ExtranetId = '';
          state.Subscriber = false;
          state.ValidAccessToken = false;
        }
      })
      .addCase(auth_load.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

// Select Property
export const selectAuthenticated = (state) => state.auth.authenticated;

export default authSlice.reducer;
export const selectRoleBenchmarks = (state) => state.auth.Benchmarks;
